import { useGateValue } from "@statsig/react-bindings";

/**
 * Custom hook to check if Meta Ads integration is enabled.
 *
 * Returns a boolean indicating whether the "enable_frontend_meta_ads_integration"
 * feature gate is enabled on Statsig.
 */
export const useEnableMetaAdsIntegration = (): boolean => {
  return useGateValue("enable_frontend_meta_ads_integration");
};
